<template>
  <!-- <el-dialog :title="moveMessage" :visible.sync="moveDialogVisible" width="50%" :before-close="closeMoveDialog"> -->
  <div>
    <div class="document-item">
      <span v-for="(breadCrumb, index) in localBreadCrumbs" :key="breadCrumb.itemId"
        @click="changeFolder({ id: breadCrumb.itemId, name: breadCrumb.name }, false)">
        {{ breadCrumb.name + ((index ===  localBreadCrumbs.length -1) ? '': ' > ') }}
      </span>
    </div>
    <hia-loading v-if="loading"></hia-loading>
    <div v-loading="loading" element-loading-spinner="particle-loader">
      <el-button v-if="loadMoreActive" @click="loadMore">LOAD MORE
      </el-button>
      <el-table v-if="!loading" :data="folderPickerCurrentDir" style="width: 100%" :highlight-current-row="true"
        size="mini" height="400">
        <el-table-column prop="name" label="" class-name="document-item"
          :height="folderPickerCurrentDir.length > 8 ? '55vh' : 'auto'">
          <template slot-scope="scope">
            <el-col :span="1">
              <i class="mdi mdi-folder folderIcon"></i>
            </el-col>
            <el-col :span="23">
              <div class="item" @click="changeFolder(scope.row, true)">
                <span style="margin: 3px 0px 0px 10px;float: left;">{{scope.row.name}}</span>
              </div>
            </el-col>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'

  export default {
    name: 'onedriveFolderPicker',
    props: {
      listId: String,
      listName: String,
      fileBreadCrumbs: {
        type: Array,
        default: function () { return [] },
        required: false
      },
      itemId: {
        type: String,
        default: '',
        required: false
      }
    },
    data() {
      return {
        loading: true,
        localBreadCrumbs: [],
        // itemId: '',
        rootItemId: ''
      }
    },
    methods: {
      ...mapActions('onedrive/', ['GET_FOLDERS', 'GET_ITEMID_FORLIST']),
      ...mapMutations('onedrive/', ['SET_CURRENTITEM']),
      initialize() {
        this.loading = true
        this.localBreadCrumbs = this.fileBreadCrumbs
        // passing in an itemId - make this be the root
        if (this.itemId) {
          this.rootItemId = this.itemId
        } else {
          this.GET_ITEMID_FORLIST(this.listId).then(response => {
            this.rootItemId = response.id
          })
        }

        let payload = {
          listId: this.listId,
          itemId: this.rootItemId,
          name: this.listName
        }
        this.setFileBreadCrumbs(payload)
        this.GET_FOLDERS(payload).then(response => {
          this.loading = false
        })
      },
      changeFolder(row, levelDown) {
        this.loading = true
        let payload = {
          listId: this.listId,
          itemId: row.id,
          name: row.name
        }
        this.GET_FOLDERS(payload).then(response => {
          // handle breadcrumbs
          this.setFileBreadCrumbs(payload, levelDown)
          this.loading = false
        })
      },
      setFileBreadCrumbs(payload, levelDown) {
        if (levelDown) {
          // clicking the table and going down - add new breadcrumb
          this.localBreadCrumbs.push(payload)
        } else {
          // from breadcrump - find clicked item, and remove all after it
          // special check for Home
          if (payload.itemId === this.rootItemId) {
            let home = {
              listId: this.listId,
              itemId: this.rootItemId,
              name: this.listName
            }
            this.localBreadCrumbs = []
            this.localBreadCrumbs.push(home)
          } else {
            let len = this.localBreadCrumbs.length
            for (var i = 0; i <= len - 1; i++) {
              if (this.localBreadCrumbs[i].itemId === payload.itemId) {
                this.localBreadCrumbs = this.localBreadCrumbs.splice(i, len - i)
                break
              }
            }
          }
        }
        this.SET_CURRENTITEM(this.localBreadCrumbs[this.localBreadCrumbs.length - 1])
      },
      loadMore() {
        this.loading = true
        let currentItem = this.localBreadCrumbs[this.localBreadCrumbs.length - 1]
        let payload = {
          listId: currentItem.listId,
          itemId: currentItem.itemId,
          nextLink: this.foldersNextLink
        }
        this.GET_FOLDERS(payload).then(response => {
          this.loading = false
        })
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('onedrive/', ['folderPickerCurrentDir', 'foldersNextLink']),
      loadMoreActive: {
        get: function () {
          return ((this.foldersNextLink !== '') && (this.foldersNextLink !== null))
        }
      }
    }
  }
</script>

<style scoped>
  >>>.document-item .item:hover {
    color: rgb(109, 207, 246);
    width: 100%;
    cursor: pointer;
  }

  >>>.document-item-selected .item {
    color: rgb(109, 207, 246);
    width: 100%;
    cursor: pointer;
    background-color: #f5f7fa;
  }

  >>>.cell {
    word-break: normal !important
  }

  #documentTable>>>tr>td:first-child .cell,
  #documentTable>>>tr>th:first-child .cell {
    text-overflow: clip;
  }

  #documentTable {
    /* max-height: 55vh;
    overflow-y: auto; */
    width: 100%;
    margin-top: 20px;
  }

  #documentTable::before {
    height: 0px !important;
  }

  #documentTable>>>.el-checkbox__input.is-checked .el-checkbox__inner {
    /*background-color: #1c3c5f;
    border-color: #1c3c5f; */
  }

  #documentTable>>>input.el-input__inner {
    height: 25px !important;
  }

  #documentTable>>>.el-checkbox__inner {
    border-radius: 10px;
  }

  >>>.documentActionMenuIcon {
    margin: 0px 5px 0px 0px;
  }

  >>>.ellipsesIcon {
    font-size: 18px;
    color: #606266;
    float: left;
    margin: 3px 0px 0px 0px;
    padding: 0px 3px 0px 3px;
    border: 1px solid transparent;
    border-radius: 100px;
    cursor: pointer;
  }

  >>>.ellipsesIcon:hover {
    font-size: 18px;
    color: #1c3c5f;
    float: left;
    margin: 3px 0px 0px 0px;
    padding: 0px 3px 0px 3px;
    border: 1px solid #1c3c5f;
    border-radius: 100px;
    cursor: pointer;
  }

  >>>.showDocItem {
    display: block;
  }

  >>>.hideDocItem {
    display: none;
  }

  /* ICON CLASSES */
  >>>.folderIcon {
    font-size: 36px;
    /* color: #f9e4b7; */
    color: #fadfad;
    float: left;
    margin: 2px 0px 0px 0px;
  }

  >>>.docName {
    float: left;
    margin: 3px 0px 0px 0px;
  }

  >>>.docIcon {
    font-size: 30px;
    color: rgba(0, 86, 149, .7);
    float: left;
    margin: 0px 0px 0px 0px;
  }

  .actionIcons {
    font-size: 16px;
    color: rgba(0, 86, 149, .7);
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
  }

  >>>.mdi-file-document-box-outline {
    color: #547b93;
  }

  >>>.mdi-image {
    color: #03284d;

  }

  >>>.mdi-file-pdf-box {
    color: #ff0021;
  }

  >>>.mdi-file-word-box {
    color: #2d5794;
  }

  >>>.mdi-file-excel-box {
    color: #2e7048;
  }

  >>>.mdi-file-cabinet {
    color: #7c4379;
  }

  >>>.mdi-outlook {
    color: #0070c0;
  }

  /* ACTION MENU */

  .actionButtonsIcon {
    font-size: 18px;
  }

  .actionButtons li {
    margin: 5px 0px 5px 0px;
    cursor: pointer;
  }

  .actionButtons li:first-child {
    margin: 0px 0px 5px 0px;
  }

  .actionButtonsItem:hover {
    background: #005695;
    padding: 4px 5px 4px 5px;
    width: 150px;
    border-radius: 30px;
    color: #ffffff;
    font-weight: normal;
  }

  .actionButtonsItemActive {
    background: #005695;
    padding: 4px 5px 4px 5px;
    width: 150px;
    text-align: center;
    border-radius: 30px;
    color: #ffffff;
    font-weight: normal;
  }

  .actionButtonsItem {
    background: transparent;
    padding: 4px 5px 4px 5px;
    width: 150px;
    border-radius: 30px;
    color: #005695;
    font-weight: normal;
  }

  .actionButtonsItem span {
    margin-left: 20px;
  }

  /* DOCUMENT TABLE STATS */
  #documentTableStats {
    padding: 0px 0px 0px 0px;
    margin: 7px 0px 0px 15px;
  }

  #documentTableStats p {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    font-size: 12px;
    font-weight: normal;
    color: #606266;
  }
</style>
